<div class="capabilities">
  <h1 class="ui-heading-1-bold capabilities-title">{{ section() }}</h1>

  <ul class="capabilities-content">
    @for (c of capabilities(); track $index) {
      <li class="capability-item">
        <h2 class="ui-heading-3">{{ c.name }}</h2>
        <p class="ui-body-l-bold">{{ c.benefit }}</p>
        <p class="ui-body-l">{{ c.description }}</p>
      </li>
    }
  </ul>
</div>
<rds-divider class="divider"></rds-divider>
